export const GET_LOCATION_LIST = "GET_LOCATION_LIST";
export const LOCATION_LIST = "LOCATION_LIST";

export const SAVE_LOCATION = "SAVE_LOCATION";
export const SAVE_LOCATION_RESPONSE = "SAVE_LOCATION_RESPONSE";

export const DELETE_LOCATION = "DELETE_LOCATION";
export const DELETE_LOCATION_RESPONSE = "DELETE_LOCATION_RESPONSE"
